const FALLBACK_TIMEZONE = 'Eastern Time (US & Canada)'

/**
 * Detects the user's timezone from the browser and matches it against
 * a list of Rails ActiveSupport::TimeZone options.
 *
 * Falls back to US Eastern if no match is found or Intl is not supported.
 */
export const detectTimezone = (options: Array<{ value: string; label: string }>): string => {
  try {
    const ianaZone = Intl.DateTimeFormat().resolvedOptions().timeZone
    const city = ianaZone.split('/').pop()?.replace(/_/g, ' ') || ianaZone
    const match = options.find((tz) => tz.value === city || tz.label.includes(city))
    if (match) return match.value
  } catch {
    // Intl not supported
  }
  return FALLBACK_TIMEZONE
}
